<template>
<div>
  <el-dialog title="选择房产" top="5vh" :visible.sync="dialogVisible" :close-on-click-modal="false" width="510px">
    <div style="height: 70vh;overflow-y: scroll;width: 500px;">
      <erp-tree-status-common @node-click="nodeClick" />
    </div>
    <div slot="footer" class="dialog-footer">
      <!-- <el-button @click="dialogVisible = false;callback=undefined">取 消</el-button> -->
      <el-button @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import ErpTreeStatusCommon from "../../Common/erp-tree-status-common-all";
export default {
  name: "SelectProjectHouse",
  components: {ErpTreeStatusCommon},
  data(){
    return{
      dialogVisible:false,
      tree_str:"",
      id:"",
      tree_obj:{},
      name:"id",
      value:"",
      callback:null,
    }
  },
  mounted() {

  },
  methods:{
    show({name='id',value=""},callback){
      const that = this;
      that.dialogVisible=true;
      that.name=name||"";
      that.value=value||"";
      that.callback=callback;
    },
    getData(){
      let data={};
      const that = this;
      if(that.value) {
        if(that.value.match(/^\d*/g)&&that.value.match(/^\d*/g).length){

        }else {

        }
        ERP.getRequest({url:"admin/",data:{}},ret=>{

        })
      }
    },
    nodeClick(data){
      // console.log(data)
      this.tree_str = data;
    },
    submit(){
      const that = this;
      typeof that.callback==="function"&&that.callback(this.tree_str)
      that.dialogVisible=false;
      that.callback=undefined;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Forms/common/SelectProjectHouse.vue